(function() {
    'use strict';

    angular.module( APP_ID )
        .directive( 'notificationOverlay', [ '$window', 'LoadingManager', 'ErrorManager', 'MetaService', 'TEXTS', 'CONFIG', NotificationOverlayDirective ]);


    /**
     * Full screen overlay displaying errors or `loading in progress` spinner.
     *
     * @param {ng.IWindowService} $window
     *
     * @type {ng.IDirectiveCompileFn}
     */
    function NotificationOverlayDirective( $window ){


        /* ===== PRIVATE MEMBERS ============================================ */


        /** @type {DOMElement} */
        var bodyElement = angular.element( $window.document.body ),


        // Static notification overlay with loading before the Angular loads
        initialNotificationElement = angular.element( $window.document.getElementById( 'init-notification-overlay' ) );


        /** @type {ng.IDirective } */
        var directiveConfig = {
            restrict:     'E',
            scope:        {},
            templateUrl:  'app/views/partials/layout/notification-overlay.html',
            controller:   NotificationController,
            controllerAs: 'vm'
        };


        NotificationController.$inject = [ '$scope', 'ErrorManager', 'LoadingManager', 'MetaService', 'DataService', 'LoggerFactory', 'CONFIG', 'TEXTS' ];



        ////////////////////////////////////////////////////////////////////////

        return directiveConfig;

        ////////////////////////////////////////////////////////////////////////



        /**
         * @param {ng.IScope} $scope
         * @param {ErrorManager} ErrorManager
         * @param {LoadingManager} LoadingManager
         * @param {MetaService} MetaService
         * @param {DataService} DataService
         * @param {LoggerFactory} LoggerFactory
         * @param {Object} CONFIG
         * @param {Object} TEXTS
         */
        function NotificationController(
            $scope,
            ErrorManager,
            LoadingManager,
            MetaService,
            DataService,
            LoggerFactory,
            CONFIG,
            TEXTS
        ){

            /** @type {angular.IController} */
            var vm = this;

            /** @type {Logger} */
            var logger = LoggerFactory.createLogger( 'NotificationOverlay' );





            /* ===== PRIVATE MEMBERS ======================================== */


            /** @constant */
            var HTTP_ERROR_STATUS_CODE  = 500,
            CLASS_OVERLAY_ON            = 'overlaid';


            var isFirstLoading          = true,
            loadingStatus               = null;





            /* ===== EXPOSE TO THE SCOPE ==================================== */


            $scope._        = TEXTS;
            $scope.CONFIG   = CONFIG;





            /* ===== PRIVATE MEMBERS ======================================== */


            // Members
            vm.loadingManager   = LoadingManager;

            vm.errors           = null;
            vm.isLoading        = false;

            vm.isOverlaid       = false;





            /* ===== RUN ON INSTANTIATION =================================== */


            /** @constructor */
            (function init() {
                LoadingManager.subscribeHandler( loadingObserverHandler );
                setWatchers();
                retrieveResponseAndBind();
            })();





            /* ===== PRIVATE FUNCTIONS ====================================== */


            function retrieveResponseAndBind(){
                DataService.getGlobals()
                    .then( function( responseObject ) {
                        vm.header = responseObject.data;
                    }).catch( function( errMessage ) {
                        logger.error( "Main site's global data couldn't be retrieved. Error: %s", errMessage );
                    }
                );
            }


            function loadingObserverHandler( status ) {
                loadingStatus = status;

                if ( isFirstLoading ){
                    firstLoadingInitialisations();
                } else {
                    invalidateLoading();
                }
            }


            function setWatchers() {
                $scope.$watch(
                    function() { return ErrorManager.criticalErrors.pending; },
                    function( isCriticalErrorPending ) {
                        if ( isCriticalErrorPending ){
                            handleCriticalErrors();
                            evaluateNotificationVisibility();
                        }
                    }
                );
            }


            function firstLoadingInitialisations() {
                if ( loadingStatus === LoadingManager.STATES.DONE || loadingStatus === LoadingManager.STATES.ABORTED ){
                    removeInitialNotificationElement();
                    toggleBodyClass();

                    isFirstLoading = false;
                }
            }


            function removeInitialNotificationElement() {
                if ( initialNotificationElement ) {
                    initialNotificationElement.remove();
                    initialNotificationElement = false;
                }
            }


            function evaluateNotificationVisibility() {
                var shouldBeOn = Boolean( vm.errors || vm.isLoading );

                if ( vm.isOverlaid !== shouldBeOn ){
                    vm.isOverlaid = shouldBeOn;
                    toggleBodyClass();
                }
            }


            function toggleBodyClass() {
                if ( vm.isOverlaid ) {
                    bodyElement.addClass( CLASS_OVERLAY_ON );
                } else {
                    bodyElement.removeClass( CLASS_OVERLAY_ON );
                }
            }


            function handleCriticalErrors() {
                bindErrors();
                ErrorManager.resolveAllCriticalErrors();

                MetaService.updateTitleStructure({
                    page: TEXTS.NOTIFICATIONS.SERVER_ERROR_META_TITLE
                });

                MetaService.updateDescriptionStructure({
                    site: null,
                    page: TEXTS.NOTIFICATIONS.SERVER_ERROR_META_DESCRIPTION
                });

                MetaService.disableIndexing();
                MetaService.addPrerenderHttpStatus( HTTP_ERROR_STATUS_CODE );
            }


            function invalidateLoading() {
                vm.isLoading = loadingStatus == LoadingManager.STATES.PENDING;

                // Reset errors when a new screen is loading
                if ( vm.isLoading && vm.errors ) bindErrors();

                evaluateNotificationVisibility();
            }


            function bindErrors() {
                vm.errors = ( ErrorManager.criticalErrors.unresolvedErrors.length ) > 0 ? ErrorManager.criticalErrors.unresolvedErrors : null;
            }


        }



    }
})();
